export default __webpack_public_path__ + "static/media/xpplus.e7d44187.svg";